"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stages = exports.Stage = exports.environments = exports.Environment = exports.Status = exports.ResponseType = exports.LanguageCode = exports.HttpStatus = exports.HttpMethod = exports.HttpContentType = exports.FileExtension = exports.FileEncoding = exports.envs = exports.Env = void 0;
var Env;
(function (Env) {
    Env["Alpha"] = "Alpha";
    Env["Beta"] = "Beta";
    Env["Development"] = "Development";
    Env["Gamma"] = "Gamma";
    Env["Pipeline"] = "Pipeline";
    Env["Production"] = "Production";
    Env["Root"] = "Root";
    Env["Unknown"] = "Unknown";
})(Env || (exports.Stage = exports.Environment = exports.Env = Env = {}));
exports.envs = Object.values(Env);
exports.environments = exports.envs;
exports.stages = exports.envs;
var FileEncoding;
(function (FileEncoding) {
    FileEncoding["ASCII"] = "ascii";
    FileEncoding["Base64"] = "base64";
    FileEncoding["Binary"] = "binary";
    FileEncoding["Hex"] = "hex";
    FileEncoding["ISO88591"] = "iso-8859-1";
    FileEncoding["ISO88592"] = "iso-8859-2";
    FileEncoding["UCS2"] = "ucs2";
    FileEncoding["UTF16LE"] = "utf16le";
    FileEncoding["UTF32"] = "utf32";
    FileEncoding["UTF8"] = "utf8";
    FileEncoding["Windows1252"] = "windows-1252";
})(FileEncoding || (exports.FileEncoding = FileEncoding = {}));
var FileExtension;
(function (FileExtension) {
    FileExtension["CSS"] = "css";
    FileExtension["CSV"] = "csv";
    FileExtension["DLL"] = "dll";
    FileExtension["DOCX"] = "docx";
    FileExtension["EXE"] = "exe";
    FileExtension["HTML"] = "html";
    FileExtension["JPG"] = "jpg";
    FileExtension["JS"] = "js";
    FileExtension["JSON"] = "json";
    FileExtension["MKV"] = "mkv";
    FileExtension["MP3"] = "mp3";
    FileExtension["MP4"] = "mp4";
    FileExtension["PDF"] = "pdf";
    FileExtension["PNG"] = "png";
    FileExtension["RAR"] = "rar";
    FileExtension["TS"] = "ts";
    FileExtension["TXT"] = "txt";
    FileExtension["XML"] = "xml";
    FileExtension["ZIP"] = "zip";
})(FileExtension || (exports.FileExtension = FileExtension = {}));
var HttpContentType;
(function (HttpContentType) {
    HttpContentType["Css"] = "text/css";
    HttpContentType["FormUrlEncoded"] = "application/x-www-form-urlencoded";
    HttpContentType["Html"] = "text/html";
    HttpContentType["Javascript"] = "application/javascript";
    HttpContentType["Json"] = "application/json";
    HttpContentType["MultipartFormData"] = "multipart/form-data";
    HttpContentType["TextPlain"] = "text/plain";
    HttpContentType["Xml"] = "application/xml";
})(HttpContentType || (exports.HttpContentType = HttpContentType = {}));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["GET"] = "GET";
    HttpMethod["HEAD"] = "HEAD";
    HttpMethod["OPTIONS"] = "OPTIONS";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
})(HttpMethod || (exports.HttpMethod = HttpMethod = {}));
var HttpStatus;
(function (HttpStatus) {
    HttpStatus[HttpStatus["Accepted"] = 202] = "Accepted";
    HttpStatus[HttpStatus["BadGateway"] = 502] = "BadGateway";
    HttpStatus[HttpStatus["BadRequest"] = 400] = "BadRequest";
    HttpStatus[HttpStatus["Conflict"] = 409] = "Conflict";
    HttpStatus[HttpStatus["Created"] = 201] = "Created";
    HttpStatus[HttpStatus["Forbidden"] = 403] = "Forbidden";
    HttpStatus[HttpStatus["GatewayTimeout"] = 504] = "GatewayTimeout";
    HttpStatus[HttpStatus["Gone"] = 410] = "Gone";
    HttpStatus[HttpStatus["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
    HttpStatus[HttpStatus["InternalServerError"] = 500] = "InternalServerError";
    HttpStatus[HttpStatus["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    HttpStatus[HttpStatus["NoContent"] = 204] = "NoContent";
    HttpStatus[HttpStatus["NotAcceptable"] = 406] = "NotAcceptable";
    HttpStatus[HttpStatus["NotFound"] = 404] = "NotFound";
    HttpStatus[HttpStatus["NotImplemented"] = 501] = "NotImplemented";
    HttpStatus[HttpStatus["Ok"] = 200] = "Ok";
    HttpStatus[HttpStatus["PartialContent"] = 206] = "PartialContent";
    HttpStatus[HttpStatus["PaymentRequired"] = 402] = "PaymentRequired";
    HttpStatus[HttpStatus["ResetContent"] = 205] = "ResetContent";
    HttpStatus[HttpStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpStatus[HttpStatus["TooManyRequests"] = 429] = "TooManyRequests";
    HttpStatus[HttpStatus["Unauthorized"] = 401] = "Unauthorized";
    HttpStatus[HttpStatus["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
})(HttpStatus || (exports.HttpStatus = HttpStatus = {}));
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["Chinese"] = "zh";
    LanguageCode["English"] = "en";
    LanguageCode["French"] = "fr";
    LanguageCode["German"] = "de";
    LanguageCode["Hindi"] = "hi";
    LanguageCode["Spanish"] = "es";
})(LanguageCode || (exports.LanguageCode = LanguageCode = {}));
var ResponseType;
(function (ResponseType) {
    ResponseType["ArrayBuffer"] = "arraybuffer";
    ResponseType["Blob"] = "blob";
    ResponseType["Document"] = "document";
    ResponseType["FormData"] = "formdata";
    ResponseType["Json"] = "json";
    ResponseType["Stream"] = "stream";
    ResponseType["Text"] = "text";
})(ResponseType || (exports.ResponseType = ResponseType = {}));
var Status;
(function (Status) {
    Status["Active"] = "Active";
    Status["Canceled"] = "Canceled";
    Status["Completed"] = "Completed";
    Status["Failed"] = "Failed";
    Status["Inactive"] = "Inactive";
    Status["Pending"] = "Pending";
    Status["Suspended"] = "Suspended";
})(Status || (exports.Status = Status = {}));
//# sourceMappingURL=misc.js.map